import React, { useEffect, useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useInventory, useUser } from 'components/hooks';
import { HeadlinePage, FormMonacoEditor } from 'components/common';
import { useTranslation } from 'react-i18next';
import { formatProjectItems, inventoryPolicies } from 'helpers';
import { useStyle } from './styles';
import { Input } from 'components/layout';
import {
  Paper,
  Grid,
  CircularProgress,
  Backdrop,
  Button,
  Typography
} from '@mui/material';
import { ROUTES } from 'consts';

export default function InventoryFormDumbOLD({ defaultValues, handleOnSubmit, isEdit }) {
  const { parameters } = useUser();
  const { isLoaded } = useInventory();
  const projects = formatProjectItems(parameters);
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { handleSubmit, reset, control } = methods;

  const fields = [
    { policy: inventoryPolicies.name },
    { policy: inventoryPolicies.project, options: projects },
  ];

  useEffect(() => {
    if (isEdit) reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.post || isLoaded.put}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage title={isEdit ? 'inventoryEdit.headline' : 'inventoryCreate.headline'} goBack={ROUTES.INVENTORY_LIST}/>
      <FormProvider { ...methods }>
        <Paper className={classes.paperStyle}>
          <form onSubmit={handleSubmit(handleOnSubmit)}>
            <Typography variant="h6" sx={{ padding: '8px 0px' }}>
              {t('inventoryList.form.title')}
            </Typography>

            <Grid container spacing={2}>
              {fields.map((field) => (
                <Grid item xs={12} sm={12} md={6} lg={4} key={field.policy.id}>
                  <Input
                    {...field.policy}
                    control={control}
                    options={field.options}
                    sx={{ width: '100%' }}
                  />
                </Grid>
              ))}

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormMonacoEditor
                  label={inventoryPolicies.additionalVariables.label}
                  name={inventoryPolicies.additionalVariables.name}
                  helperText={inventoryPolicies.additionalVariables.helperText}
                  methods={methods}
                  language={'ini'}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ mt: 4 }}>
              <Grid item md={2} lg={3} />
              <Grid item xs={12} sm={12} md={8} lg={6}>
                <Button variant="contained" sx={{ width: '100%' }} type='submit'>
                  {isEdit ? t('inventoryEdit.components.submit') : t('inventoryCreate.components.submit')}
                </Button>
              </Grid>
              <Grid item md={2} lg={3} />
            </Grid>
          </form>
        </Paper>
      </FormProvider>
    </>
  );
}
